<template>
  <div id="check">
    <div class="card">
      <h3>直播名称</h3>
      <p>{{liveName}}</p>
    </div>
    <div class="card">
      <h3>活动名称</h3>
      <p>{{activityName}}</p>
    </div>
    <div class="card">
      <h3>奖品名称</h3>
      <p>{{prizeName}}</p>
    </div>
    <div class="btns">
      <a @click="cancel">返回扫码</a>
      <a @click="check">确认</a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import tool from "../../kits/Tools.js";
import { Dialog } from "vant";
import { Toast } from "vant";
//保存数据

export default {
  data() {
    return {
      liveName: "",
      activityName: "",
      prizeName: "",
      type: "",
      data0: "",
      data1: "",
      data2: "",
      data3: "",
      data4: "",
      code: ""
    };
  },
  mounted() {
    this.type = tool.getQueryString("type");
    this.data0 = tool.getQueryString("data0");
    this.data1 = tool.getQueryString("data1");
    this.data2 = tool.getQueryString("data2");
    this.getData();
  },
  methods: {
    getData() {
      var that = this;
      var option =
        "type=" +
        this.type +
        "&data0=" +
        this.data0 +
        "&data1=" +
        this.data1 +
        "&data2=" +
        this.data2;
      this.axios.defaults.withCredentials = true;
      console.log(document.cookie);
      this.axios
        .post(tool.baseUrl() + "/coupon/verify/auth", option)
        .then(function(res) {
          var data = res.data;
          if (data.code == "200") {
            that.data3 = data.data.data3;
            that.data4 = data.data.data4;
            that.code = data.data.code;
            that.liveName = data.data.name;
            that.activityName = data.data.activity_name;
            that.prizeName = data.data.prize_name;
          } else {
            Toast(data.message);
          }
        })
        .catch(function() {
          console.log("错误");
        });
    },
    check() {
      var that = this;
      var option =
        "type=" +
        this.type +
        "&data3=" +
        this.data3 +
        "&data4=" +
        this.data4 +
        "&code=" +
        this.code;
      this.axios
        .post(tool.baseUrl() + "/coupon/verify/past", option)
        .then(function(res) {
          var data = res.data;
          if (data.code == "200") {
            Toast(data.message);
            setTimeout(function() {
              that.$router.push({ path: "/scan" });
            }, 2000);
          } else {
            Toast(data.message);
          }
        })
        .catch(function() {
          console.log("错误");
        });
    },
    cancel() {
      this.$router.push({ path: "/scan" });
    }
  }
};
</script>

<style scoped>
#check {
  background: #f5f5f5;
  min-height: 100%;
}

.card {
  padding: 0 5px;
  background: #fff;
  margin-bottom: 10px;
}

.card h3 {
  line-height: 50px;
  border-bottom: 1px solid #b5b5b5;
  color: #858585;
  font-size: 19px;
}

.card p {
  color: #323232;
  font-size: 17px;
  line-height: 30px;
  min-height: 60px;
  padding: 10px 0;
}

.btns {
  display: flex;
  padding: 10px;
}

.btns a {
  display: block;
  margin: 0 10px;
  background: #c8c8c8;
  color: #fff;
  text-align: center;
  height: 45px;
  line-height: 45px;
  border-radius: 3px;
  flex: 1;
  font-size: 18px;
}

.btns a:nth-child(2n) {
  background: #4a7ae6;
}
</style>


// WEBPACK FOOTER //
// check.vue?0f8daf56